import { GridItem } from 'components/Grid/Grid';
import { defaultTheme } from 'constants/theme/defaultTheme';
import styled from 'styled-components';
import { breakpoints } from 'stylesheet';
import { getSpacingPx } from 'constants/spacing';
import { heightOfNavPx } from '../components/ProductsHeader/styles';
import Image from 'next/image';

export const Styles = {
  ThumbImage: styled(Image)`
    aspect-ratio: auto !important;
    max-width: auto !important;
    width: auto !important;
    min-width: auto !important;
  `,
  BodyContainer: styled.div`
    padding: 0;
    padding-bottom: ${defaultTheme.spacing(30)}; // provides space behind the sticky footer
    @media (min-width: ${breakpoints.small}) {
      padding-bottom: ${defaultTheme.spacing(30)}; // provides space behind the sticky footer
    }
  `,
  ContentContainer: styled.div`
    margin-bottom: ${defaultTheme.spacing(15)};
    @media (max-width: ${breakpoints.medium}) {
      padding: 0 ${defaultTheme.spacing(4)};
    }
  `,
  ImageContainer: styled.div`
    @media (max-width: ${breakpoints.small}) {
      display: flex;
      justify-content: center;
      background-color: ${defaultTheme.colors.snowGrey};
    }
  `,
  GridImageItem: styled(GridItem)`
    align-self: start;
    margin-bottom: ${defaultTheme.spacing(4)};
    @media (min-width: ${breakpoints.small}) {
      margin: 0 ${defaultTheme.spacing(10)} ${defaultTheme.spacing(10)} 0;
    }

    @media (min-width: ${breakpoints.medium}) {
      top: ${getSpacingPx(8) + heightOfNavPx}px;
      position: sticky;
    }
  `,
  ImageBackgroundContainer: styled.div`
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    max-width: 400px;
    background-color: ${defaultTheme.colors.snowGrey};
    width: 100%;

    @media (min-width: ${breakpoints.small}) {
      min-width: 300px;
      max-width: 400px;
    }
    @media (min-width: ${breakpoints.large}) {
      min-width: 400px;
      max-width: 620px;
    }
  `,
  TitleContainer: styled.div`
    margin-bottom: ${defaultTheme.spacing(1)};
  `,
  TitleContainerLarge: styled.div`
    margin: ${defaultTheme.spacing(5)} 0;
  `,
  TitleContainerSlider: styled.div`
    margin-bottom: ${defaultTheme.spacing(7.5)};
  `,
  ButtonWrapper: styled.div`
    @media (min-width: ${breakpoints.small}) {
      width: 290px;
    }
  `,
  SkuGrid: styled.div`
    padding: ${defaultTheme.spacing(8)} ${defaultTheme.spacing(2)};
    background-color: ${defaultTheme.colors.whiteSmoke};
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    @media (min-width: ${breakpoints.small}) {
      padding: 0 ${defaultTheme.spacing(2)};
    }
  `,
};
